import { Slider, styled } from '@mui/material';
export const CustomSlider = styled(Slider)({
    color: '#3b82f6',
    height: 2,
    padding: '10px 0',
    '& .MuiSlider-rail': {
        backgroundColor: '#e5e7eb',
        opacity: 1,
    },
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        width: 12,
        height: 12,
        backgroundColor: '#3b82f6',
        boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
        '&:hover, &.Mui-focusVisible, &.Mui-active': {
            boxShadow: '0px 0px 0px 6px rgba(59, 130, 246, 0.16)',
        },
    },
    '& .MuiSlider-mark': {
        backgroundColor: '#d9d9d9',
        width: '1px',
        height: 8,
        transform: 'translateY(-3px)',
    },

    '& .MuiSlider-valueLabel': {
        fontSize: 10,
        fontWeight: 'normal',
        fontFamily: 'sans-serif',
        top: -2,
        backgroundColor: '#595959',
        borderRadius: 4,
        padding: '2px 6px',
        '&:before': { display: 'none' },
    },
});
